export { NearbySchoolsModule } from './NearbySchoolsModule';
export {
  buildAllTabOrdering,
  computeNearestSchools,
  getGradeLabel,
  getSchoolTypeLabel,
  groupSchoolsByType,
  hasNearbySchoolsData,
} from './schoolUtils';
